import { injectable } from 'inversify';
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from '@xlearn/common'
import * as SerializationApi from '@/app/state-serialization/api'
import { ProtobufSerializer } from '@/app/state-serialization/infrastructure';
import { TabsState } from './tabs-interfaces';
import { StateSerializerName } from '@/app/state-serialization/api';

@injectable()
abstract class TabsStateProtobufSerializer implements SerializationApi.StateSerializationPlugin<TabsState> {

  abstract key: { id: number, name: StateSerializerName, format: string }

  serialize(data: TabsState): Result<Uint8Array, SerializationApi.SerializerError> {

    const message = new TabsStateProtoMessage({
      selectedIndex: data.selectedIndex,
      touched: data.touched,
    })

    return ProtobufSerializer.serialize<TabsStateProtoMessage>(message, TabsStateProtoMessage)
  }

  deserialize(content: Uint8Array): Result<TabsState, SerializationApi.DeserializerError> {

    const deserializeResult = ProtobufSerializer.deserialize<TabsStateProtoMessage>(content, TabsStateProtoMessage)
    if (!deserializeResult.success) {
      return deserializeResult
    }

    const message = deserializeResult.value
    const result: TabsState = {
      selectedIndex: message.selectedIndex,
      touched: message.touched,
    }
    
    return ok(result)
  }
}

@injectable()
export class VerticalTabsStateProtobufSerializer extends TabsStateProtobufSerializer {
  key = { id: 37, name: { ns: 'interaction-suspend-data',
                          name: 'vertical-tabs' }, format: 'protobuf' }
}

@injectable()
export class HorizontalTabsStateProtobufSerializer extends TabsStateProtobufSerializer {
  key = { id: 38, name: { ns: 'interaction-suspend-data',
                          name: 'horizontal-tabs' }, format: 'protobuf' }
}

@Type.d('TabsStateProtoMessage')
class TabsStateProtoMessage extends Message<TabsStateProtoMessage> {
  @Field.d(1, 'int32', 'optional', 0)
  selectedIndex: number;

  @Field.d(2, 'bool', 'repeated')
  touched: boolean[];
}
